/**
 * Madrasa module permission keys (must match Fakhri-api PERMISSIONS).
 * Madrasa resources are a separate set from the Jamaat resources.
 */
export const MADRASA_SETTINGS_VIEW = "madrasaSettings.view";
export const MADRASA_SETTINGS_EDIT = "madrasaSettings.edit";

export const MADRASA_CLASSES_VIEW = "madrasaClasses.view";
export const MADRASA_CLASSES_CREATE = "madrasaClasses.create";
export const MADRASA_CLASSES_EDIT = "madrasaClasses.edit";
export const MADRASA_CLASSES_DELETE = "madrasaClasses.delete";

export const MADRASA_STUDENTS_VIEW = "madrasaStudents.view";
export const MADRASA_STUDENTS_CREATE = "madrasaStudents.create";
export const MADRASA_STUDENTS_EDIT = "madrasaStudents.edit";
export const MADRASA_STUDENTS_DELETE = "madrasaStudents.delete";

export const MADRASA_ENROLLMENTS_VIEW = "madrasaEnrollments.view";
export const MADRASA_ENROLLMENTS_CREATE = "madrasaEnrollments.create";
export const MADRASA_ENROLLMENTS_EDIT = "madrasaEnrollments.edit";
export const MADRASA_ENROLLMENTS_DELETE = "madrasaEnrollments.delete";

export const MADRASA_FEE_SETUP_VIEW = "madrasaFeeSetup.view";
export const MADRASA_FEE_SETUP_CREATE = "madrasaFeeSetup.create";
export const MADRASA_FEE_SETUP_EDIT = "madrasaFeeSetup.edit";
export const MADRASA_FEE_SETUP_DELETE = "madrasaFeeSetup.delete";

export const MADRASA_FEES_VIEW = "madrasaFees.view";
export const MADRASA_FEES_CREATE = "madrasaFees.create";
export const MADRASA_FEES_VOID = "madrasaFees.void";
